import { type FunctionComponent, useEffect } from "react";
import type { PathRouteProps } from "react-router";

export interface TitleRouteProps extends PathRouteProps {
    title?: string;
}

export const TitleRoute: FunctionComponent<TitleRouteProps> = ({
    title,
    ...routeProps
}) => {
    if(!title) {
        title = "Shopfront | Point of Sale";
    }

    useEffect(() => {
        if(typeof document !== "undefined") {
            document.title = title as string;
        }
    }, [ title ]);

    return <>{routeProps.element}</>;
};
